// Section file — populated during component conversion.
import React from "react";

const lang = {
  balance: {
    title: "Agregar saldo",
    subtitle: "Recarga tu saldo de boosts para enviar interacciones al instante.",
    errSelectBoth: "Por favor selecciona un monto y un método de pago",
    errFillCardDetails: "Por favor completa todos los datos de la tarjeta",
    errPaymentFailed: "El pago falló",
    errPaymentFailedTryAgain: "El pago falló. Por favor intenta de nuevo.",
    errSelectAmount: "Por favor selecciona un monto",
    selectAmount: "Selecciona el monto",
    // Saldo de bonificación que se muestra en cada opción de recarga.
    getsBalance: (credit) => `Recibe $${credit}`,
    bonusAmount: (bonus) => `+$${bonus} de bono`,
    customNoBonus: "Sin bono",
    youReceive: "Recibes",
    custom: "Otro",
    enterAmountPlaceholder: "Ingresa el monto",
    minTopup: (min) => `La recarga mínima es de $${min}.`,
    total: "Total",
    paymentMethod: "Método de pago",
    addNewCard: "Agregar nueva tarjeta",
    cardNumber: "Número de tarjeta",
    expiry: "Vencimiento",
    cvv: "CVV",
    processing: "Procesando...",
    pay: (amount) => `Pagar $${amount}`,
    secure: "Seguro",
    instant: "Instantáneo",
    encrypted: "Encriptado",
  },

  tools: {
    items: {
      trends: { label: "Analizador de tendencias", desc: "análisis de tendencias con IA" },
      story: { label: "Visor de historias", desc: "visor de historias con IA" },
      download: { label: "Descargador de posts", desc: "descargador de posts con IA" },
      caption: { label: "Generador de captions", desc: "generación de captions con IA" },
      idea: { label: "Generador de ideas", desc: "generación de ideas con IA" },
      profile: { label: "Mejorador de perfil", desc: "mejora de perfil con IA" },
      photo: { label: "Revisor de fotos", desc: "revisión de fotos con IA" },
      collab: { label: "Buscador de colabs", desc: "buscador de colaboraciones con IA" },
    },
    basicFeature: "Función Basic",
    proFeature: "Función Pro",
    tierBasicOrPro: "Basic o Pro",
    tierPro: "Pro",
    upgradeToUnlock: (tier, desc) => `Mejora a ${tier} para desbloquear ${desc}`,
    upgradeNow: "Mejorar ahora",
    badgePro: "PRO",
    badgeBasic: "BASIC",
    startingDelivery: (type, amount, link) =>
      `¡Iniciando la entrega de ${type}!\nCantidad: ${amount}\nEnlace del post: ${link}`,
  },

  toolsCaption: {
    heading: "Generador de captions",
    subtitle: "Sube una foto y genera un caption garantizado para hacerse viral.",
    copied: "¡Copiado al portapapeles!",
    uploadError: (msg) => `Ocurrió un error al subir la imagen: ${msg}`,
    generateError: (msg) => `Ocurrió un error al generar el caption: ${msg}`,
    unknownError: "Error desconocido",
    success: "Captions generados con éxito.",
    closeAria: "Cerrar",
    uploadTitle: "Haz clic para subir una imagen",
    generateButton: "Generar caption",
  },

  toolsCollab: {
    heading: "Buscador de colabs",
    subtitle: "Ingresa un usuario de Instagram para encontrar perfiles afines con quienes conectar.",
    enterUsername: "Por favor ingresa un usuario de Instagram",
    success: (count) => `Se encontraron ${count} perfiles con éxito.`,
    fetchFailed: "No se pudieron obtener los competidores",
    usernamePlaceholder: "Usuario",
    analyzing: (count) => `Analizando... (${count} perfiles escaneados)`,
    analyze: "Analizar",
    similarityTooltip: "Puntaje de similitud calculado por IA según el contenido, la audiencia y los patrones de interacción",
  },

  toolsDownload: {
    heading: " Descargador de posts ",
    subtitle: "Ingresa un usuario o enlace para descargar.",
    success: "Se encontraron posts para descargar con éxito.",
    downloadError: (msg) => `Ocurrió un error al descargar el post: ${msg}`,
    inputLabel: "Usuario o URL del post",
    inputPlaceholder: "Ingresa un usuario o enlace de post",
    buttonEmpty: "Ingresa un usuario o enlace de post",
    buttonDownloadPost: "Descargar post",
    buttonSearchProfile: "Buscar perfil",
    noPosts: " No se encontraron posts",
    tabPosts: "Posts",
    tabReels: "Reels",
    videoUnsupported: "Tu navegador no soporta la etiqueta de video.",
    loading: "Cargando...",
    loadMore: "Cargar más",
    noMoreData: "No hay más datos",
  },

  toolsIdea: {
    heading: "Generador de ideas",
    subtitle: "Crea ideas únicas para videos con el poder de la IA.",
    success: "Ideas generadas con éxito.",
    generateError: (msg) => `Ocurrió un error al generar la idea: ${msg}`,
    unknownError: "Error desconocido",
    goalLabel: "Selecciona tu objetivo",
    goalAria: "Selecciona tu objetivo",
    goals: {
      none: "-- Elige un objetivo --",
      brandAwareness: "Aumentar el reconocimiento de marca",
      boostEngagement: "Impulsar la interacción",
      productLaunch: "Lanzar un nuevo producto",
      increaseSales: "Aumentar las ventas",
      educateAudience: "Educar a la audiencia",
    },
    targetAudienceLabel: "Audiencia objetivo",
    targetAudiencePlaceholder: "¿A quién te diriges? p. ej. Jóvenes adultos, fans de la tecnología",
    topicLabel: "Tema / Nicho",
    topicPlaceholder: "p. ej. Moda, Tecnología, Cocina",
    toneLabel: "Tono preferido",
    toneAria: "Selecciona tu tono",
    tones: {
      none: "-- Elige un tono --",
      informative: "Informativo",
      casual: "Casual",
      humorous: "Humorístico",
      persuasive: "Persuasivo",
    },
    generateButton: "Generar idea",
  },

  toolsPhoto: {
    heading: "Revisor de fotos",
    subtitle: "Sube una foto para recibir sugerencias con IA que maximicen la interacción y mejoren tu contenido.",
    uploadError: (msg) => `Ocurrió un error al subir la imagen: ${msg}`,
    unknownError: "Error desconocido",
    selectImage: "Por favor selecciona una imagen para revisar",
    invalidResponse: "Formato de respuesta del servidor inválido",
    unexpectedError: "Ocurrió un error inesperado",
    reviewError: (msg) => `Ocurrió un error al revisar la foto: ${msg}`,
    success: "Revisión generada con éxito.",
    closeAria: "Cerrar",
    uploadTitle: "Haz clic para subir una imagen",
    reviewing: "Revisando...",
    reviewButton: "Revisar foto",
    sectionVisualAppeal: "Atractivo visual",
    sectionComposition: "Composición",
    sectionEngagementPotential: "Potencial de interacción",
    sectionOptimizationTips: "Consejos de optimización",
  },

  toolsProfile: {
    heading: "Mejorador de perfil",
    subtitle: "Ingresa tu usuario para recibir una renovación de perfil con IA y una comparación de antes y después.",
    success: "Perfil analizado con éxito.",
    scanError: (msg) => `Ocurrió un error al escanear el perfil: ${msg}`,
    unknownError: "Error desconocido",
    usernamePlaceholder: "Ingresa tu usuario",
    analyzing: "Analizando...",
    scanButton: "Escanear perfil",
    posts: "Posts",
    followers: "Seguidores",
    following: "Siguiendo",
    noBio: "Sin bio",
    before: "ANTES",
    after: "DESPUÉS",
    whatWeChanged: "Qué cambiamos y por qué",
    bio: "Bio",
    displayName: "Nombre visible",
    profilePhoto: "Foto de perfil",
    quickWins: "Mejoras rápidas para aplicar ahora",
  },

  toolsStory: {
    heading: "Visor de historias",
    subtitle: "Mira la historia en vivo de alguien de forma anónima.",
    success: "Historia vista con éxito.",
    viewError: (msg) => `Ocurrió un error al ver la historia: ${msg}`,
    unknownError: "Error desconocido",
    usernameLabel: "Usuario",
    usernamePlaceholder: "Ingresa un usuario",
    viewButton: "Ver historia",
    noPosts: "No se encontraron posts",
    videoUnsupported: "Tu navegador no soporta la etiqueta de video.",
  },

  toolsTrends: {
    heading: "Analizador de tendencias",
    subtitle: "Obtén insights en tiempo real sobre las tendencias actuales de Instagram/TikTok y estrategias de contenido viral relevantes para ti.",
    invalidData: "Estructura de datos de tendencias inválida",
    invalidResponse: "Formato de respuesta del servidor inválido",
    unexpectedError: "Ocurrió un error inesperado",
    success: "Tendencias analizadas con éxito.",
    analyzeError: (msg) => `Ocurrió un error al analizar las tendencias: ${msg}`,
    ranges: {
      week: "Última semana",
      month: "Último mes",
      year: "Último año",
    },
    customFocusLabel: "Enfoque personalizado (opcional)",
    customFocusPlaceholder: "P. ej. Tendencias de baile, productos de belleza, Drake, etc.",
    analyzing: (count) => `Analizando... (${count} posts procesados)`,
    analyzeButton: "Analizar tendencias actuales",
    sections: {
      trends: "Contenido en tendencia",
      hooks: "Ganchos de video",
      audio: "Audios populares",
      engagement: "Tácticas de interacción",
      themes: "Temas de contenido",
      technical: "Estrategias técnicas",
    },
  },

  analytics: {
    welcomeBack: "Bienvenido de nuevo,",
    basicPlan: "Plan Basic",
    balanceLabel: "Saldo:",
    loading: "Cargando",
    followers: "Seguidores",
    following: "Siguiendo",
    tabOverview: "Resumen",
    tabGrowthSettings: "Ajustes de crecimiento",
    linkHeading: "Vincula tu perfil de Instagram",
    linkSubtitle: "¡Tu cuenta está a 1 paso de crecer!",
    instagramPlaceholder: "Ingresa tu usuario de Instagram",
    instagramAria: "Usuario de Instagram",
    linkAccount: "Vincular cuenta",
    profileLinked: (username) => `¡Perfil vinculado! Bienvenido de nuevo ${username}`,
    settingsSaved: (interests, ageRange, gender, instagram) =>
      `¡Ajustes guardados!\nIntereses: ${interests}\nRango de edad: ${ageRange}\nGénero: ${gender}\nInstagram: ${instagram}`,
    saveFailed: (msg) => `No se pudieron guardar los ajustes: ${msg}`,
    enterValidUsername: "Por favor ingresa un usuario de Instagram válido.",
    linkFailed: (msg) => `No se pudo vincular la cuenta de Instagram: ${msg}`,
    growthSettingsHeading: "Ajustes de crecimiento",
    growthSettingsSubtitle: "Ajusta aquí tus preferencias de crecimiento.",
    selectInterests: "Selecciona los intereses objetivo",
    interests: {
      fitness: "Fitness",
      travel: "Viajes",
      fashion: "Moda",
      tech: "Tecnología",
      food: "Comida",
      music: "Música",
      art: "Arte",
      gaming: "Gaming",
      photography: "Fotografía",
      sports: "Deportes",
      health: "Salud",
      beauty: "Belleza",
      books: "Libros",
      movies: "Películas",
      pets: "Mascotas",
    },
    targetAgeRange: "Rango de edad objetivo",
    ageRangeYears: (low, high) => `${low} - ${high} años`,
    targetGender: "Género objetivo",
    male: "Hombres",
    female: "Mujeres",
    both: "Ambos",
    saveSettings: "Guardar ajustes",
  },

  checkout: {
    title: "Pago",
    paymentError: (msg) => `Error al procesar el pago: ${msg}`,
    unknownError: "Error desconocido",
    purchaseSuccessful: "¡Compra exitosa!",
    close: "Cerrar",
    planTitle: (planName) => `Plan ${planName}`,
    annualSubscription: "Suscripción anual",
    monthlySubscription: "Suscripción mensual",
    discountApplied: "¡50% de descuento aplicado!",
    subtotal: "Subtotal",
    discount: "Descuento",
    total: "Total",
    paymentMethod: "Método de pago",
    addNewCard: "Agregar nueva tarjeta",
    cardNumberPlaceholder: "Número de tarjeta",
    cvvPlaceholder: "CVV",
    processing: "Procesando...",
    purchase: "Comprar",
  },

  buySpins: {
    title: "Comprar giros",
    subtitle: "Los giros extra se agregan a tu cuenta al instante.",
    packs: {
      single: { label: "1 giro extra" },
      pack: { label: "Pack de 5 giros", badge: "Ahorra $5" },
    },
    errSelectPayment: "Por favor selecciona un método de pago.",
    errFillCardDetails: "Completa todos los datos de la tarjeta.",
    errPurchaseFailed: "La compra falló.",
    selectPack: "Selecciona el pack",
    spinsCount: (n) => `${n} giro${n === 1 ? "" : "s"}`,
    paymentMethod: "Método de pago",
    addNewCard: "Agregar nueva tarjeta",
    cardNumber: "Número de tarjeta",
    expiry: "Vencimiento",
    cvv: "CVV",
    processing: "Procesando…",
    pay: (price) => `Pagar $${price}`,
    secure: "Seguro",
    instant: "Instantáneo",
    encrypted: "Encriptado",
  },

  followerChart: {
    followers: "Seguidores",
  },

  profileSwitcher: {
    addAccount: "Agregar cuenta",
    badgePro: "PRO",
    badgeBasic: "BASIC",
    badgeStarter: "STARTER",
    badgeNoPlan: "SIN PLAN",
    addAnotherAccount: "Agregar otra cuenta",
  },

  visualizer: {
    plans: {
      starter: {
        name: "Starter",
        tagline: "Una forma simple de empezar a crecer.",
        features: [
          "Seguidores",
          "El crecimiento de seguidores empieza al instante",
          "Segmentación de audiencia con IA",
        ],
      },
      basic: {
        name: "Core",
        tagline: "Crecimiento más fuerte y constante.",
        features: [
          "Seguidores",
          "El crecimiento de seguidores empieza al instante",
          "Segmentación de audiencia con IA mejorada",
          "Asistente de contenido con IA",
          "Soporte prioritario",
        ],
      },
      pro: {
        name: "Elite",
        tagline: "Crecimiento de máxima calidad y máxima prioridad.",
        features: [
          "Seguidores",
          "El crecimiento de seguidores empieza al instante",
          "Segmentación de audiencia con IA premium",
          "Gerente de cuenta dedicado",
          "Soporte y entrega prioritarios",
        ],
      },
    },
    scanSteps: [
      "Buscando tu perfil",
      "Analizando tu audiencia",
      "Identificando tu nicho",
      "Calculando tu potencial de crecimiento",
    ],
    errEnterUsername: "Por favor ingresa un usuario y selecciona una plataforma",
    errFetchFailed: "No se pudieron obtener los datos del perfil",
    badge: "Análisis de seguidores gratis",
    headingJSX: (
      <>
        Mira tu potencial de <span className="text-instagram">crecimiento exacto</span>
      </>
    ),
    subheading: "Ingresa tu usuario y te mostraremos exactamente cuántos seguidores ganarás — personalizado para tu cuenta.",
    recommendedForYou: "Recomendado para ti",
    choosePlatform: "Elige tu plataforma",
    // Flujo de reclamo del impulso gratis — reemplaza el escaneo.
    boostBadge: "Seguidores gratis — sin contraseña",
    boostHeadingJSX: (
      <>
        Reclama tus <span className="text-instagram">seguidores gratis</span>
      </>
    ),
    boostSubheading: "Ingresa tu usuario y te enviamos tu impulso de seguidores gratis ahora mismo — sin contraseña ni tarjeta.",
    // Marca bajo el regalo, y la palabra que estalla en pantalla.
    boostBrandLine1: "Seguidores Gratis",
    boostBrandLine2: "Boost",
    boostWord: "¡BOOST!",
    boostCta: "Reclamar gratis →",
    boostFineprint: "Un impulso gratis por persona.",
    boostActivating: "Activando tus seguidores gratis...",
    boostSteps: [
      "Localizando tu cuenta",
      "Reservando tus seguidores gratis",
      "Enviándolos a tu perfil",
      "Creando tu plan de crecimiento",
    ],
    boostDelivered: (n) => `${n} seguidores gratis están en camino`,
    boostAlreadyClaimed: "Ya reclamaste tu impulso gratis — aquí está tu plan de crecimiento.",
    boostPrivateWarning: "Tu cuenta es privada. Ponla en público para poder entregar tus seguidores.",
    customizeTitle: "Personaliza tus seguidores",
    // Se antepone al subtítulo con los seguidores mensuales del plan elegido.
    customizeFollowerCount: (n) => `${n} Seguidores`,
    customizeSubtitle: "Ajusta a quién le llegamos y qué tan rápido creces.",
    // Complementos de personalización de pago.
    addonIncluded: "Incluido",
    addonPlus: (p) => `+$${p}`,
    addonTotalLabel: "Nuevo total",
    targetingLabel: "Segmentación",
    femaleOnlyTitle: "Solo seguidoras",
    femaleOnlySub: "Nos dirigiremos exclusivamente a mujeres.",
    usaOnlyTitle: "Solo seguidores de EE. UU.",
    usaOnlySub: "Nos dirigiremos exclusivamente a cuentas de Estados Unidos.",
    customizeContinue: "Continuar al pago →",
    customizeBack: "← Volver a los planes",
    deliverySpeedLabel: "Velocidad de entrega",
    speedTurbo: "Turbo",
    speedFast: "Súper instantánea",
    speedGradual: "Gradual",
    // Ventana de entrega mostrada debajo de cada velocidad.
    speedTurboSub: "Al instante",
    speedFastSub: "La entrega empieza en segundos.",
    speedGradualSub: "Entrega progresiva",
    audienceLabel: "Audiencia",
    audienceEveryone: "Todos",
    audienceMen: "Hombres",
    audienceWomen: "Mujeres",
    locationLabel: "Ubicación",
    locationUsa: "EE. UU.",
    locationWorldwide: "Todo el mundo",
    locationChoose: "Elegir país",
    countryPlaceholder: "Selecciona un país",
    handlePlaceholder: "tuusuario",
    search: "Buscar",
    analyze: "Analizar →",
    noPassword: "Sin contraseña",
    takesSeconds: "Toma segundos",
    analyzingAccount: "Analizando tu cuenta...",
    currentlyFollowers: (n) => (
      <>
        Actualmente <strong style={{ color: "#0a2540" }}>{n}</strong> seguidores
      </>
    ),
    projectedGrowth: "Crecimiento proyectado",
    youllGain: (n) => (
      <>
        Ganarás <strong style={{ color: "#0a2540" }}>{n}</strong> nuevos seguidores en 30 días
      </>
    ),
    growthPct: (pct) => `+${pct}% de crecimiento`,
    before: "Antes",
    currentFollowers: "Seguidores actuales",
    after30Days: "Después",
    projectedFollowers: "Seguidores esperados",
    perMo: "/mes",
    fiftyOff: "50% OFF",
    whatsIncluded: "Qué incluye",
    followersPerMonth: (low, high) => `${high}+ Seguidores`,
    choosePlan: "Empieza a crecer →",
    noPasswordRequired: "No se requiere contraseña",
    cancelAnytime: "Cancela cuando quieras",
    tryDifferent: "← Prueba con otro usuario",
  },
};

export default lang;
